import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import {
  Enum,
  IdentityVerificationDto,
  TaxFormDto,
} from '@fantaz/shared/data-access/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TaxService {
  constructor(private http: HttpClient) {}

  saveTaxInfo(data: TaxFormDto) {
    return this.http.post(
      `${environment.apiBaseUrl}/core/client/api/taxinfoencrypted`,
      data,
    );
  }

  saveIdentityVerification(
    data: IdentityVerificationDto,
  ): Observable<Enum | null> {
    return this.http.post<Enum>(
      `${environment.apiBaseUrl}/core-client/api/kyc/user`,
      data,
    );
  }
}
